export function sortOnKeys(dict) {

    var sorted = [];
    for (var key in dict) {
        sorted[sorted.length] = key;
    }
    sorted.sort();

    var tempDict = {};
    for (var i = 0; i < sorted.length; i++) {
        tempDict[sorted[i]] = dict[sorted[i]];
    }

    return tempDict;
}

export function greeting() {
    var currentTime = new Date();
    currentTime.getHours();
    var currentHour = currentTime.getHours();
    switch (true) {
        case (currentHour < 12):
            return "Good morning! ";
            break;
        case (currentHour > 12 && currentHour < 17):
            return "Good afternoon! "
            break;
        default:
            return "Good evening! ";
            break;
    }
}

export function locale(key) {
    var dict = {
        "csv": "CSV",
        "quickbooks_online": "QuickBooks Online",
        "quickbooks_desktop": "QuickBooks Desktop",
        "order": "Order",
        "customer": "Customer",
        "product": "Product",
        "JobService.DoWorkCustomer": "Customer",
        "JobService.DoWorkProduct": "Product",
        "JobService.DoWorkOrder": "Order",
        "orders": "Order",
        "quotes": "Quote",
        "order": "Order",
        "quote": "Quote",
        "group": "Group",
    }

    return dict[key]
}

export function formatDate(dbDateString) {

    // Create a new Date object with the database date string
    const dbDate = new Date(dbDateString);

    // Get the machine timezone offset in minutes
    const timezoneOffset = new Date().getTimezoneOffset();

    // Convert the timezone offset to milliseconds
    const timezoneOffsetMs = timezoneOffset * 60 * 1000;

    // Get the machine date by adding the timezone offset to the database date
    const machineDate = new Date(dbDate.getTime() - timezoneOffsetMs);

    // Format the machine date as a string in the machine timezone
    return machineDate.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        // second: 'numeric',
        //timeZone: 'UTC',
        hour12: false
    }).replaceAll(',', '')
}
